import { $, $$ } from 'utils/dom';
import { overlayHtml } from './overlayHtml';
import { observe } from '../media/player/player.js';

const audiotour = $('.audiotour');

if (audiotour) {
  const transformPlyrConfig = config => {
    /*
     * TYPO3 give us the time as string, but we need it as number. Or else plyr will dont render the markers correctly
     * So we take all the points and transform the time to a real number
     */
    config.markers.points = config.markers.points.map(point => ({
      label: point.label,
      time: parseFloat(point.time),
    }));
    return config;
  };

  const getStationObject = () => {
    const audioStations = $$('.audiotour__station', audiotour);

    const stationsStore = {};

    audioStations.forEach((item, index) => {
      const itemObject = {};
      const headlines = $$('h4', item);

      itemObject.audioFile = item.getAttribute('data-audio');
      itemObject.plyrConfig = transformPlyrConfig(
        JSON.parse(item.getAttribute('data-plyr-config'))
      );
      itemObject.images = JSON.parse(item.getAttribute('data-images'));
      itemObject.headline = headlines[0].innerHTML;
      itemObject.copy = $('p', item).innerHTML;
      itemObject.station = headlines[1].innerHTML;
      itemObject.index = index;

      const id = item.getAttribute('data-station-id');
      itemObject.id = id;
      stationsStore[id] = itemObject;
    });

    return stationsStore;
  };

  const trapFocus = element => {
    const focusableEls = $$(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
      element
    );
    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];
    const KEYCODE_TAB = 9;

    element.addEventListener('keydown', function (e) {
      const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    });
  };

  const generateImageHTML = station => {
    return station.images
      .map((image, index) => {
        const html = /* html */ `<li class="audiotour-overlay__image" data-id="id-${
          index + 1
        }">
        <picture>
          <source srcset="${image.mobile}" media="(max-width: 900px)">
          <img src="${image.desktop}" alt="${image.alt}">
        </picture>
      </li>`;
        return html;
      })
      .join('');
  };

  const generateImageNavigationHTML = station => {
    return station.images
      .map((image, index) => {
        const html = /* html */ `<li>
        <button class="audiotour-overlay__image-nav-button" data-id="id-${
          index + 1
        }" type="button">
          <span class="sr-only">Klick</span>
        </button>
      </li>`;
        return html;
      })
      .join('');
  };

  const initImageGalleryHandlers = () => {
    const overlay = $('.audiotour-overlay');

    const setActive = (button, key) => {
      const images = $$('.audiotour-overlay__image', overlay);
      const buttons = $$('.audiotour-overlay__image-nav-button', overlay);

      buttons.forEach((button, index) => {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');

      images.forEach((image, index) => {
        if (image.getAttribute('data-id') === button.getAttribute('data-id')) {
          image.classList.add('is-active');
        } else if (key !== index) {
          image.classList.remove('is-active');
        }
      });
    };

    const images = $$('.audiotour-overlay__image', overlay);
    const buttons = $$('.audiotour-overlay__image-nav-button', overlay);

    images[0].classList.add('is-active');

    if (buttons.length) {
      buttons[0].classList.add('is-active');
    }

    if (images.length > 1 && buttons.length > 1) {
      buttons.forEach((button, key) => {
        button.addEventListener('click', () => {
          setActive(button, key);
        });
      });
    }
  };

  let player;

  function setPlyrEvents(event) {
    player = event.detail.plyr;
    player.muted = false;

    initControl();

    player.on('playing', () => setPlyrTime(player.currentTime));

    player.on('ended', () => {
      const playButton = $('.audio-control__button-play');
      playButton.classList.remove('audio-control__button-play--playing');
    });
  }

  function initTime() {
    const duration = $('.audiotour-overlay__audio-progress [data-duration]');
    const currentTime = $(
      '.audiotour-overlay__audio-progress [data-current-time]'
    );

    // set duration (we need to wait until the duration is available)
    setTimeout(() => (duration.innerText = formatTime(player.duration)), 500);

    // set currentTime
    currentTime.innerText = formatTime(player.currentTime);

    // update times whenever the currenTime is updating
    player.on('timeupdate', () => setPlyrTime(player.currentTime));
  }

  function setPlyrTime(currentTime) {
    const durationEl = $('.audiotour-overlay__audio-progress [data-duration]');
    const currentTimeEl = $(
      '.audiotour-overlay__audio-progress [data-current-time]'
    );

    currentTimeEl.innerText = formatTime(currentTime);
    durationEl.innerText = `-${formatTime(player.duration - currentTime)}`;
  }

  function togglePlyr(event) {
    const plyrPlayButton = $(
      '.audiotour-overlay .plyr__control[data-plyr="play"]'
    );
    const playButton = event.currentTarget;

    plyrPlayButton.click();

    if (player.playing) {
      playButton.classList.add('audio-control__button-play--playing');
    } else {
      playButton.classList.remove('audio-control__button-play--playing');
    }
  }

  function rewindPlyr() {
    const rewindButton = $(
      '.audiotour-overlay .plyr__control[data-plyr="rewind"]'
    );
    rewindButton.click();
  }

  function forwardPlyr() {
    const forwardButton = $(
      '.audiotour-overlay .plyr__control[data-plyr="fast-forward"]'
    );
    forwardButton.click();
  }

  function mutePlyr() {
    const soundButton = $('.audio-control__button-sound');

    if (player.muted) {
      player.muted = false;
      soundButton.classList.remove('audio-control__button-sound--muted');
    } else {
      player.muted = true;
      soundButton.classList.add('audio-control__button-sound--muted');
    }
  }

  // convert number into 00:00 format
  const formatTime = number => {
    const minutes = Math.floor(number / 60);
    const seconds = Math.floor(number - minutes * 60);
    const minutesValue = minutes < 10 ? `0${minutes}` : minutes;
    const secondsValue = seconds < 10 ? `0${seconds}` : seconds;
    return `${minutesValue}:${secondsValue}`;
  };

  const initPlyr = () => {
    const audio = $('.plyr-wrapper');
    audio && observe([audio]);
    audio.addEventListener('ready', setPlyrEvents);
    audio.addEventListener('ready', initTime);
  };

  const destroyPlayer = player => {
    player.destroy();

    // prevent multiple event listeners by removing current event listeners
    const audio = $('.plyr-wrapper');
    audio.removeEventListener('ready', setPlyrEvents);
    audio.removeEventListener('ready', initTime);

    const playButton = $('.audio-control__button-play');
    playButton.removeEventListener('click', togglePlyr);
    playButton.classList.remove('audio-control__button-play--playing');

    const rewindButton = $('.audio-control__button-rewind');
    rewindButton.removeEventListener('click', rewindPlyr);

    const forwardButton = $('.audio-control__button-forward');
    forwardButton.removeEventListener('click', forwardPlyr);

    const soundButton = $('.audio-control__button-sound');
    soundButton.removeEventListener('click', mutePlyr);
    soundButton.classList.remove('audio-control__button-sound--muted');

    const duration = $('.audiotour-overlay__audio-progress [data-duration]');
    duration.innerText = '00:00';
  };

  const initControl = () => {
    const playButton = $('.audio-control__button-play');
    const rewindButton = $('.audio-control__button-rewind');
    const forwardButton = $('.audio-control__button-forward');
    const soundButton = $('.audio-control__button-sound');

    // toggle play status
    playButton.addEventListener('click', togglePlyr);

    // rewind player back
    rewindButton.addEventListener('click', rewindPlyr);

    // fast-forward player back
    forwardButton.addEventListener('click', forwardPlyr);

    // mute/unmute player
    soundButton.addEventListener('click', mutePlyr);
  };

  const openOverlay = (id, button) => {
    const stations = getStationObject();
    const station = stations[id];
    // heads up: objekte sortieren automatisch ihre keys, wenn diese number-like sind. deswegen gehen wir umständlich über den index des objektes vor
    const stationsArray = Object.values(stations)
      .sort((a, b) => a.index - b.index)
      .map(station => station.id);
    const buttonClicked = button;

    audiotour.insertAdjacentHTML('afterend', overlayHtml);

    const overlay = $('.audiotour-overlay');
    const overlayHeadline = $('.audiotour-overlay__headline', overlay);
    const overlayCopy = $('.audiotour-overlay__copy', overlay);
    const overlayStation = $('.audiotour-overlay__station', overlay);
    const overlayImages = $('.audiotour-overlay__image-wrapper', overlay);
    const overlayImagesNav = $(
      '.audiotour-overlay__image-nav-wrapper',
      overlay
    );
    const overlayAudio = $('.audiotour-overlay__audio source', overlay);
    const prevButton = $('.is-prev', overlay);
    const nextButton = $('.is-next', overlay);
    const closeButton = $('.audiotour-overlay__close', overlay);

    if (station != null) {
      closeButton.focus();
      trapFocus(overlay);
      overlay.setAttribute('data-station-id', id);
      overlayHeadline.insertAdjacentHTML('beforeend', station.headline);
      overlayCopy.insertAdjacentHTML('beforeend', station.copy);
      overlayStation.insertAdjacentHTML('beforeend', station.station);
      overlayAudio.src = station.audioFile;
      overlayAudio.parentElement.load(); // we need to load the new src in order to really set the new audio file
      // TODO: merge with overHTML data-plyr-config
      overlayAudio.parentElement.dataset.plyrConfig = JSON.stringify(
        station.plyrConfig
      );

      const imageHTML = generateImageHTML(station);
      overlayImages.insertAdjacentHTML('beforeend', imageHTML);

      const imageNavigationHTML = generateImageNavigationHTML(station);

      if (station.images.length > 1) {
        overlayImagesNav.insertAdjacentHTML('beforeend', imageNavigationHTML);
      }

      initPlyr();

      const initPaginationButtons = button => {
        if (stationsArray.length === 1) {
          button.setAttribute('disabled', '');
        }
        if (station.index === 0) {
          prevButton.setAttribute('disabled', '');
        }
        if (station.index + 1 === stationsArray.length) {
          nextButton.setAttribute('disabled', '');
        }
      };

      initImageGalleryHandlers();

      const resetImageGallery = () => {
        const images = $$('.audiotour-overlay__image', overlay);
        const buttons = $$('.audiotour-overlay__image-nav-button', overlay);

        images.forEach(image => {
          image.classList.remove('is-active');
        });
        images[0].classList.add('is-active');

        if (buttons.length) {
          buttons.forEach(button => {
            button.classList.remove('is-active');
          });
          buttons[0].classList.add('is-active');
        }
      };

      const disableEnablePaginationButtons = () => {
        const idCurrent = overlay.getAttribute('data-station-id');
        let counter = stations[idCurrent].index;
        if (prevButton) {
          counter++;
        }
        if (nextButton) {
          counter--;
        }
        if (counter > 0) {
          prevButton.removeAttribute('disabled');
        }
        if (counter < 1) {
          prevButton.setAttribute('disabled', '');
        }
        if (counter < stationsArray.length - 1) {
          nextButton.removeAttribute('disabled');
        }
        if (counter === stationsArray.length - 1) {
          nextButton.setAttribute('disabled', '');
        }
      };

      const paginate = button => {
        const isNextButton = button.classList.contains('is-next');
        const overlayId = overlay.getAttribute('data-station-id');
        const overlayIndex = isNextButton
          ? stations[overlayId].index + 1
          : stations[overlayId].index - 1;

        overlay.setAttribute('data-station-id', stationsArray[overlayIndex]);

        const prevNextStation = stations[stationsArray[overlayIndex]];

        overlayHeadline.textContent = prevNextStation.headline;
        overlayCopy.textContent = prevNextStation.copy;
        overlayStation.textContent = prevNextStation.station;

        // destroy current player
        if (player) destroyPlayer(player);

        // change audio file and setting
        const overlayAudio = $('.audiotour-overlay__audio source', overlay);
        overlayAudio.src = prevNextStation.audioFile;
        overlayAudio.parentElement.load(); // we need to load the new src in order to really set the new audio file
        overlayAudio.parentElement.dataset.plyrConfig = JSON.stringify(
          prevNextStation.plyrConfig
        );

        // re-init plyr
        initPlyr();

        // refresh gallery
        const overlayImages = $('.audiotour-overlay__image-wrapper', overlay);
        const overlayImagesNav = $(
          '.audiotour-overlay__image-nav-wrapper',
          overlay
        );

        const imageHTML = generateImageHTML(prevNextStation);
        overlayImages.innerHTML = imageHTML;

        const imageNavigationHTML =
          generateImageNavigationHTML(prevNextStation);

        if (prevNextStation.images.length > 1) {
          overlayImagesNav.innerHTML = imageNavigationHTML;
        } else {
          overlayImagesNav.innerHTML = '';
        }

        initImageGalleryHandlers();
      };

      const prevNextButtons = $$('.audioguide-overlay__prev-next', overlay);

      prevNextButtons.forEach(button => {
        initPaginationButtons(button);
        button.addEventListener('click', () => {
          paginate(button);
          disableEnablePaginationButtons();
          resetImageGallery();
        });
      });
    }

    const closeOverlay = () => {
      overlay.remove();
    };

    closeButton.addEventListener('click', () => {
      closeOverlay();
      buttonClicked.focus();
    });
  };

  const svgButtons = $$('.audiotour__map-button', audiotour);
  svgButtons.forEach(button => {
    const id = button.getAttribute('id');
    button.addEventListener('click', () => {
      openOverlay(id, button);
    });
  });

  const overlayOpenButtons = $$('.audiotour__item-button', audiotour);

  overlayOpenButtons.forEach(button => {
    const id = button.getAttribute('data-station-id');
    button.addEventListener('click', () => {
      openOverlay(id, button);
    });
  });
}
